export interface AckTexts {
  heading: string;
  subtitle: string;
  question: string;
  yes: string;
  no: string;
}

// The acknowledgment screen mirrors what the learner sees, so it follows the
// narration language chosen at generation time (keys from LANGUAGE_CONFIG).
const ACK_TEXTS: {[languageKey: string]: AckTexts} = {
  en: {
    heading: 'Before you continue',
    subtitle: 'Please confirm to complete this microreel',
    question: 'Click Yes to acknowledge you have watched the Microreel',
    yes: 'Yes',
    no: 'No',
  },
  es: {
    heading: 'Antes de continuar',
    subtitle: 'Confirma para completar este microreel',
    question: 'Haz clic en Sí para confirmar que has visto el microreel',
    yes: 'Sí',
    no: 'No',
  },
  fr: {
    heading: 'Avant de continuer',
    subtitle: 'Veuillez confirmer pour terminer ce microreel',
    question:
      'Cliquez sur Oui pour confirmer que vous avez regardé le microreel',
    yes: 'Oui',
    no: 'Non',
  },
  de: {
    heading: 'Bevor Sie fortfahren',
    subtitle: 'Bitte bestätigen Sie, um dieses Microreel abzuschließen',
    question:
      'Klicken Sie auf Ja, um zu bestätigen, dass Sie das Microreel gesehen haben',
    yes: 'Ja',
    no: 'Nein',
  },
  cy: {
    heading: 'Cyn i chi barhau',
    subtitle: "Cadarnhewch i gwblhau'r microreel hwn",
    question: "Cliciwch Ydw i gadarnhau eich bod wedi gwylio'r microreel",
    yes: 'Ydw',
    no: 'Nac ydw',
  },
  it: {
    heading: 'Prima di continuare',
    subtitle: 'Conferma per completare questo microreel',
    question: 'Fai clic su Sì per confermare di aver guardato il microreel',
    yes: 'Sì',
    no: 'No',
  },
  pt: {
    heading: 'Antes de continuar',
    subtitle: 'Confirme para concluir este microreel',
    question: 'Clique em Sim para confirmar que assistiu ao microreel',
    yes: 'Sim',
    no: 'Não',
  },
  nl: {
    heading: 'Voordat u verdergaat',
    subtitle: 'Bevestig om deze microreel af te ronden',
    question: 'Klik op Ja om te bevestigen dat u de microreel heeft bekeken',
    yes: 'Ja',
    no: 'Nee',
  },
  pl: {
    heading: 'Zanim przejdziesz dalej',
    subtitle: 'Potwierdź, aby ukończyć ten microreel',
    question: 'Kliknij Tak, aby potwierdzić obejrzenie microreela',
    yes: 'Tak',
    no: 'Nie',
  },
  sv: {
    heading: 'Innan du fortsätter',
    subtitle: 'Bekräfta för att slutföra denna microreel',
    question: 'Klicka på Ja för att bekräfta att du har sett microreelen',
    yes: 'Ja',
    no: 'Nej',
  },
  da: {
    heading: 'Før du fortsætter',
    subtitle: 'Bekræft for at fuldføre denne microreel',
    question: 'Klik på Ja for at bekræfte, at du har set microreelen',
    yes: 'Ja',
    no: 'Nej',
  },
  cs: {
    heading: 'Než budete pokračovat',
    subtitle: 'Potvrďte pro dokončení tohoto microreelu',
    question: 'Kliknutím na Ano potvrďte, že jste microreel zhlédli',
    yes: 'Ano',
    no: 'Ne',
  },
  bg: {
    heading: 'Преди да продължите',
    subtitle: 'Потвърдете, за да завършите този микрорийл',
    question: 'Натиснете Да, за да потвърдите, че сте гледали микрорийла',
    yes: 'Да',
    no: 'Не',
  },
  el: {
    heading: 'Πριν συνεχίσετε',
    subtitle: 'Επιβεβαιώστε για να ολοκληρώσετε αυτό το microreel',
    question:
      'Πατήστε Ναι για να επιβεβαιώσετε ότι παρακολουθήσατε το microreel',
    yes: 'Ναι',
    no: 'Όχι',
  },
  tr: {
    heading: 'Devam etmeden önce',
    subtitle: "Bu microreel'i tamamlamak için onaylayın",
    question: "Microreel'i izlediğinizi onaylamak için Evet'e tıklayın",
    yes: 'Evet',
    no: 'Hayır',
  },
  hu: {
    heading: 'Mielőtt továbblépne',
    subtitle: 'Erősítse meg a microreel befejezéséhez',
    question:
      'Kattintson az Igen gombra annak megerősítéséhez, hogy megnézte a microreelt',
    yes: 'Igen',
    no: 'Nem',
  },
  ar: {
    heading: 'قبل المتابعة',
    subtitle: 'يرجى التأكيد لإكمال هذا المايكروريل',
    question: 'انقر نعم لتأكيد أنك شاهدت المايكروريل',
    yes: 'نعم',
    no: 'لا',
  },
  he: {
    heading: 'לפני שתמשיך',
    subtitle: 'אשר כדי להשלים את המיקרוריל',
    question: 'לחץ כן כדי לאשר שצפית במיקרוריל',
    yes: 'כן',
    no: 'לא',
  },
  hi: {
    heading: 'आगे बढ़ने से पहले',
    subtitle: 'इस माइक्रोरील को पूरा करने के लिए पुष्टि करें',
    question:
      'पुष्टि करने के लिए हाँ पर क्लिक करें कि आपने माइक्रोरील देख ली है',
    yes: 'हाँ',
    no: 'नहीं',
  },
  bn: {
    heading: 'এগিয়ে যাওয়ার আগে',
    subtitle: 'এই মাইক্রোরিল সম্পূর্ণ করতে নিশ্চিত করুন',
    question: 'মাইক্রোরিল দেখেছেন তা নিশ্চিত করতে হ্যাঁ ক্লিক করুন',
    yes: 'হ্যাঁ',
    no: 'না',
  },
  zh: {
    heading: '在继续之前',
    subtitle: '请确认以完成此微短片',
    question: '点击"是"确认您已观看该微短片',
    yes: '是',
    no: '否',
  },
  bs: {
    heading: 'Prije nego što nastavite',
    subtitle: 'Potvrdite da biste završili ovaj microreel',
    question: 'Kliknite Da kako biste potvrdili da ste pogledali microreel',
    yes: 'Da',
    no: 'Ne',
  },
  ca: {
    heading: 'Abans de continuar',
    subtitle: 'Confirmeu per completar aquest microreel',
    question: 'Feu clic a Sí per confirmar que heu vist el microreel',
    yes: 'Sí',
    no: 'No',
  },
  az: {
    heading: 'Davam etməzdən əvvəl',
    subtitle: 'Bu microreel-i tamamlamaq üçün təsdiqləyin',
    question: 'Microreel-ə baxdığınızı təsdiqləmək üçün Bəli düyməsinə basın',
    yes: 'Bəli',
    no: 'Xeyr',
  },
  kk: {
    heading: 'Жалғастырмас бұрын',
    subtitle: 'Осы microreel-ді аяқтау үшін растаңыз',
    question: 'Microreel-ді көргеніңізді растау үшін Иә түймесін басыңыз',
    yes: 'Иә',
    no: 'Жоқ',
  },
};

export const getAckTexts = (languageKey?: string): AckTexts =>
  (languageKey && ACK_TEXTS[languageKey]) || ACK_TEXTS.en;
